<template>
  <div>
    <v-sheet class="mx-auto mt-8 pt-12" elevation="8" max-width="1200" min-height="350px">
      <v-row justify="center">
        <h1 class="primary--text mt-1">หนังสือจำหน่าย</h1>

        <!-- <pre>{{detail_book}}</pre> -->
        <!-- {{model}} -->
        <v-btn
          class="float-right ml-5 mt-0"
          color="#636262"
          text
          fab
          @click="openSetting()"
          v-if="mode"
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-row>
      <p class="ml-10 pl-10" v-if="detail_book==''">- ไม่มีข้อมูล</p>
      <v-slide-group v-model="model" class="pa-4" show-arrows v-if="detail_book!=''">
        <v-slide-item v-for="(card,i) in detail_book" :key="i" v-slot:default="{ active, toggle }">
          <v-row dense>
            <v-col justify="center">
              <v-card class="ma-4" height="300" width="200" @click="toggle">
                <v-img
                  :src="env+'/'+ card.book_file_path"
                  class="white--text align-end"
                  height="300px"
                >
                  <v-card-title class="py-0" style=" background: #000000;opacity:0.5">
                    <v-list-item-content>
                      <v-list-item-title style="line-height:1.6;">{{card.book_name}}</v-list-item-title>
                    </v-list-item-content>
                  </v-card-title>
                </v-img>
                <v-row class="fill-height" align="center" justify="center"></v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-slide-item>
      </v-slide-group>
      <v-expand-transition>
        <v-sheet v-if="model != null" color="grey lighten-4" tile>
          <v-row class="px-10 pt-2">
            <v-col cols="12">
              <h2>{{detail_book[model].book_name}}</h2>
              <v-card-text
                style="font-size:18px; color:#660033;"
              >รายละเอียด : {{detail_book[model].book_detail}}</v-card-text>
              <v-card-text
                style="font-size:16px; color:red;"
                class="pt-0"
              >ราคา : {{detail_book[model].book_price}}.-</v-card-text>
            </v-col>
          </v-row>
        </v-sheet>
      </v-expand-transition>
    </v-sheet>
    <DialogBook ref="dialog_book_setting" @getBook="getBookDetail();getBookFile()"></DialogBook>
  </div>
</template>
<script>
import DialogBook from "../Settings/DialogBook";
export default {
  components: {
    DialogBook,
  },
  data: () => ({
    env: process.env.VUE_APP_API,
    mode: false,
    model: null,
    book: [],
    detail_book: [],
  }),
  created() {
    this.mode = this.$session.get("token")
      ? this.$session.get("permission") == "admin"
      : false;
    this.getBookFile();
    this.getBookDetail();
  },
  methods: {
    openSetting() {
      this.$refs.dialog_book_setting.openSetting();
    },
    getBookFile() {
      let book_file = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/book_file")
        .then((response) => {
          // console.log(response.data);
          book_file = response.data;
          this.book = book_file;
        });
    },
    getBookDetail() {
      let book_detail = [];
      this.axios
        .get(process.env.VUE_APP_API + "/api/v1/book_all")
        .then((response) => {
          // console.log(response.data);
          book_detail = response.data;

          this.detail_book = book_detail;
          // this.detail_book.forEach((element, index) => {
          //   element.book_src = this.cards[index].src;
          // });
        });
    },
  },
};
</script>
